import React, { useCallback, useMemo, useState } from 'react';
import styles from './Item.module.css';
import { useLang } from '../../hooks/useLang';
function Item(props) {
    var _a;
    const [hovering, setHovering] = useState(false);
    function fireEvent(event) {
        if (props[event])
            props[event](props.item);
    }
    const lang = useLang();
    const onMouseEnter = useCallback(() => {
        setHovering(true);
        fireEvent('onItemHoverIn');
    }, []);
    const onMouseLeave = useCallback(() => {
        fireEvent('onItemHoverOut');
        setHovering(false);
    }, []);
    const onClick = useCallback((event) => {
        if (props.item.disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        props.item.onClick();
    }, []);
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Enter' || event.code === 'Space') {
            onClick(event);
        }
    }, []);
    const cleanStyles = useCallback(() => {
        const styles = props.style;
        if (!styles)
            return {};
        delete styles.normal.borderRadius;
        return styles;
    }, [props.style]);
    const hoveringStyle = useCallback(() => {
        var _a;
        if (hovering)
            return Object.assign(Object.assign({}, (_a = props.style) === null || _a === void 0 ? void 0 : _a.hover), props.item.hoverStyle);
        return {};
    }, [hovering]);
    const rowClassName = useMemo(() => {
        var _a, _b, _c, _d, _e;
        const disabled = props.item.disabled ? ((_a = props.item.disabledClassName) !== null && _a !== void 0 ? _a : styles.disabledRow) : '';
        const className = (_b = props.className) !== null && _b !== void 0 ? _b : ((_d = styles[`${(_c = props.variant) === null || _c === void 0 ? void 0 : _c.theme}MenuRow`]) !== null && _d !== void 0 ? _d : styles.lightMenuRow);
        const itemClassName = (_e = props.item.className) !== null && _e !== void 0 ? _e : '';
        return `${styles.menuRow} ${disabled} ${className} ${itemClassName}`;
    }, [props.className, props.item.className, props.item.disabled, props.item.disabledClassName, (_a = props.variant) === null || _a === void 0 ? void 0 : _a.theme]);
    return (React.createElement("div", { key: props.index, role: 'menuitem', "aria-label": lang.contextmenuitem, "aria-disabled": props.item.disabled, ref: props.itemRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: rowClassName, onClick: onClick, onKeyDown: onKeyDown, tabIndex: 0, style: Object.assign(Object.assign(Object.assign({}, cleanStyles()), props.item.style), hoveringStyle()) },
        React.createElement("div", null, props.item.label)));
}
export default Item;
